import { IAppOverlayProps } from '../../../../core/types/IAppOverlay';
import appStore from '../../../../core/stores/AppStore';

export const manageAppOverlay = (value?: IAppOverlayProps) => {
  appStore.setAppOverlay(value || null);
};
